/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'logout': {
    width: 21.5,
    height: 16.5,
    viewBox: '0 0 21.5 16.5',
    data: '<path  pid="0" _fill="#005EB8" d="M14.14,5.59a.94.94,0,0,0,.9-1V2.07A2,2,0,0,0,13.14,0H1.9A2,2,0,0,0,0,2.07V14.43A2,2,0,0,0,1.9,16.5H13.14A2,2,0,0,0,15,14.43V11.89a.91.91,0,1,0-1.81,0v2.54c0,.06,0,.12-.09.12H1.9s-.09-.06-.09-.12V2.07c0-.06,0-.12.09-.12H13.14s.09.06.09.12V4.61A1,1,0,0,0,14.14,5.59Z"/><path d="M17.45,12.84a.75.75,0,0,1-.47-.18.88.88,0,0,1-.1-1.29l2-2.26H9.29a.86.86,0,0,1,0-1.72h9.57l-2-2.26A.88.88,0,0,1,17,3.84a.73.73,0,0,1,1.05.1l3.21,3.6a1.06,1.06,0,0,1,0,1.4L18,12.56A.79.79,0,0,1,17.45,12.84Z"/>'
  }
})